const React = require('react')
const { useState } = require('react')
const { useParams, useHistory } = require('react-router-dom')
const { useNetworkConfig } = require('@contexts')
const { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } = require('reactstrap')
const { NETWORK_CONFIG } = require('@configs')

require('@styles/pages/address/statistics.address.css')

const MultichainBalanceDropdown = props => {
    const { multichainBalance } = props
    const { address } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()

    const [dropdownOpen, setDropdownOpen] = useState(false)

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <span>
                {multichainBalance.length} address{multichainBalance.length > 1 ? 'es' : ''} found via&nbsp;
            </span>
            <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)} className='dark-dropdown'>
                <DropdownToggle caret style={{ fontSize: '12px' }}>
                    VBchain's Multichain
                </DropdownToggle>
                <DropdownMenu style={{ padding: '0px' }}>
                    {multichainBalance.map(item => (
                        <DropdownItem
                            className={`${network.name}-dropdown-item`}
                            key={item.name}
                            style={{ fontSize: '12px' }}
                            onClick={() => {
                                history.push(`/${NETWORK_CONFIG[item.name].shortName}/address/${address}`)
                            }}
                        >
                            {NETWORK_CONFIG[item.name].networkIcon && (
                                <img
                                    src={NETWORK_CONFIG[item.name].networkIcon}
                                    style={{ marginRight: '8px', width: '20px' }}
                                />
                            )}
                            {NETWORK_CONFIG[item.name].name}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}

module.exports = { MultichainBalanceDropdown }
